import { id, root } from './hardware-statuses';

export const hardwareStatuses = {
  ...root,
  id,
};
